import {Component, Input, ViewChild} from '@angular/core';
import {Clipboard} from '@angular/cdk/clipboard';
import {Common} from '../../util/Util';

@Component({
  selector: 'app-copy-to-clipboard-button',
  templateUrl: './copy-to-clipboard-button.component.html',
  styleUrls: ['./copy-to-clipboard-button.component.scss']
})
export class CopyToClipboardButtonComponent {
  @Input() buttonText: string;
  @Input() payload: string;

  isCopied: boolean;

  @ViewChild('copyButton', {static: true}) private copyButton;

  constructor(private clipboard: Clipboard) {
  }

  copyCommand() {
    if (!this.payload) {
      return;
    }
    const pending = this.clipboard.beginCopy(this.payload);
    let remainingAttempts = 3;
    const attempt = () => {
      const result = pending.copy();
      if (!result && --remainingAttempts) {
        setTimeout(attempt);
      }
      else {
        // Remember to destroy when you're done!
        pending.destroy();

        this.isCopied = !this.isCopied;
        this.copyButton.nativeElement.blur();
        setTimeout(() => {
          this.isCopied = !this.isCopied;
        }, Common.TWO_SECOND_DEBOUNCE);
      }
    };
    attempt();
  }

}
